var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgKeeptruckinLogo = function SvgKeeptruckinLogo(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33.59px",
    height: "32px",
    viewBox: "0 0 1982 1888",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "keeptruckin-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.06 0.85 1981.71568 0.85 1981.71568 1888 0.06 1888"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "keeptruckin-icon",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1020,1.045 L1020,1887.81 L1852.68,1887.81 C1904.44,1887.81 1947.46,1847.89 1951.34,1796.27 C2009.47,1023.6 1969.51,334.169 1951.52,92.593 C1947.68,40.954 1904.66,1.045 1852.88,1.045 L1020,1.045",
    id: "Fill-1",
    fill: "#4A7EB0",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.583,1888 L951.632,1888 L951.632,0.85 L128.387,0.85 C76.562,0.85 33.523,40.822 29.733,92.508 C12.009,334.189 -27.324,1023.57 29.913,1796.35 C33.74,1848.02 76.779,1888 128.583,1888",
    id: "Fill-3",
    fill: "#51514E",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-5",
    fill: "#FFFFFE",
    points: "452.66 1070.95 410.283 1159.58 410.283 1457.33 273.178 1457.33 273.178 487.914 410.283 487.914 410.283 910.302 589.764 487.914 726.869 487.914 536.169 919.997 726.869 1457.33 586.025 1457.33 452.66 1070.95"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-6",
    fill: "#FFFFFE",
    points: "1284.48 487.914 1708.25 487.914 1708.25 626.402 1564.92 626.402 1564.92 1457.33 1427.81 1457.33 1427.81 626.402 1284.48 626.402 1284.48 487.914"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgKeeptruckinLogo);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "assets/logos/keeptruckin-logo.cb970fb622c3f77c78c3872f2ee6e019.svg";